module.exports = __webpack_public_path__ + "static/media/PT.7f22e2eb.png";